<template>
  <a-layout class="">
    <a-card :bordered="false">
      <a-form
        ref="formRef"
        :model="pageData.data"
        :rules="formCp.rules"
        :label-col="formCp.labelCol"
        :wrapper-col="formCp.wrapperCol"
      >
        <SmallSquare class="mb-25" content="客户信息" />
        <a-form-item label="公司名称" name="company">
          <a-input
            v-model:value="pageData.data.company"
            placeholder="请输入公司名称"
          />
        </a-form-item>
        <a-form-item label="负责人" name="director_name">
          <a-input
            v-model:value="pageData.data.director_name"
            placeholder="请输入负责人"
          />
        </a-form-item>
        <a-form-item label="负责人电话" name="director_phone">
          <a-input-number
            style="width: 100%"
            v-model:value="pageData.data.director_phone"
            placeholder="请输入负责人电话"
          />
        </a-form-item>
        <a-form-item label="品牌名称" name="brand_name">
          <a-input
            v-model:value="pageData.data.brand_name"
            placeholder="请输入品牌名称"
          />
        </a-form-item>
        <a-form-item label="账号" name="account">
          <a-input
            v-model:value="pageData.data.account"
            placeholder="请输入账号"
          />
        </a-form-item>
        <a-form-item label="密码" name="password">
          <a-input
            v-model:value="pageData.data.password"
            placeholder="请输入密码"
          />
        </a-form-item>

        <a-form-item label="营业执照" name="business_license_img">
          <div class="flex">
            <div class="flex overflow-hidden">
              <a-image-preview-group
                class="overflow-hidden"
                v-if="pageData.data.business_license_img"
              >
                <a-image
                  class="overflow-hidden"
                  :width="100"
                  :height="100"
                  :src="info.picdomain + pageData.data.business_license_img"
                />
              </a-image-preview-group>
            </div>
            <div class="w-100 h-100 relative ml-10" v-if="!pageDatum.isDetail">
              <div
                class="w-0100 h-0100 flex items-center justify-center border-1 border-dashed "
                style="border-color: #ddd;"
              >
                <PlusOutlined />
              </div>
              <uploadImage
                @success="uploadOnSuccess('business_license_img', $event)"
                class="opacity-0 absolute left-0 top-0 w-0100 h-0100 z-1"
              ></uploadImage>
            </div>
          </div>
        </a-form-item>

        <a-form-item label="商品注册证" name="product_reg_cert_img">
          <div class="flex">
            <div class="flex overflow-hidden">
              <a-image-preview-group
                class="overflow-hidden"
                v-if="pageData.data.product_reg_cert_img"
              >
                <a-image
                  class="overflow-hidden"
                  :width="100"
                  :height="100"
                  :src="info.picdomain + pageData.data.product_reg_cert_img"
                />
              </a-image-preview-group>
            </div>
            <div class="w-100 h-100 relative ml-10" v-if="!pageDatum.isDetail">
              <div
                class="w-0100 h-0100 flex items-center justify-center border-1 border-dashed "
                style="border-color: #ddd;"
              >
                <PlusOutlined />
              </div>
              <uploadImage
                @success="uploadOnSuccess('product_reg_cert_img', $event)"
                class="opacity-0 absolute left-0 top-0 w-0100 h-0100 z-1"
              ></uploadImage>
            </div>
          </div>
        </a-form-item>

        <a-form-item label="公司地址">
          <a-cascader
            v-model:value="addressCp.data"
            :field-names="{
              label: 'name',
              value: 'id',
              children: 'children'
            }"
            :options="addressCp.options"
            placeholder="请选择地址"
            @change="addressOnChange"
          />
        </a-form-item>

        <a-form-item label="所属行业" name="industry">
          <a-select
            v-model:value="pageData.data.industry"
            placeholder="请选择所属行业"
          >
            <a-select-option
              v-for="item in industryCp.options"
              :key="item"
              :value="item"
            >
              {{ item }}
            </a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item label="详细地址" name="company_address">
          <a-input
            v-model:value="pageData.data.company_address"
            placeholder="请输入详细地址"
          />
        </a-form-item>

        <SmallSquare class="mb-25" content="开通产品" />

        <a-form-item label="产线" name="is_production_line">
          <a-radio-group v-model:value="pageData.data.is_production_line">
            <a-radio :value="0">关闭</a-radio>
            <a-radio :value="1">开启</a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item label="SaaS应用" name="app_marks">
          <a-checkbox-group
            v-model:value="pageData.data.app_marks"
            :options="productCp.options"
          />
        </a-form-item>

        <a-row class="py-20">
          <a-col :span="20" :offset="2">
            <a-button type="primary" @click="formOnSubmit"> 保存 </a-button>
          </a-col>
        </a-row>
      </a-form>
    </a-card>
    <!-- 选择礼品 start -->
    <a-modal
      :keyboard="false"
      v-model:visible="modalCp.show"
      centered
      style="width: 700px"
      :width="1200"
      :footer="null"
      destroyOnClose
    >
    </a-modal>
    <!-- 选择礼品 end -->
  </a-layout>
</template>
<script>
import { ref, onMounted, reactive, toRaw, toRefs, inject } from "vue";
import { message } from "ant-design-vue";
import { $iscode } from "@/utils/app";
import {
  WarningOutlined,
  CheckOutlined,
  PlusOutlined
} from "@ant-design/icons-vue";

import {
  getAccountApplyForDetail,
  updateAccountApplyFor,
  getBrandIndustrys
} from "@/api/brand";
import { brandGetAppCost } from "@/api/product";
import { getArea } from "@/api/public";
import uploadImage from "@/components/image/uploadImage.vue";

// 初始化默认筛选项数值
export default {
  components: { PlusOutlined, uploadImage },
  setup() {
    const $route = inject("$route");
    const $Modal = inject("$Modal");
    const $router = inject("$router");
    const $store = inject("$store");
    const _lodash = inject("_lodash");
    const info = $store.state.user.info;
    /* 路由数据、缓存等数据 start */
    let pageDatum = reactive({
      // 编辑时候，从列表页哪页过来的
      page: $route.query.page,
      // 进入页面的类型，详情是look，编辑是edit、评审是review
      pageType: $route.query.type,
      // 编辑、详情用到的详情id
      id: $route.query.id,

      // 是add页面
      isAdd: true,
      // 是详情页
      isDetail: false,
      // 是编辑页
      isEdit: false
    });
    /* 路由数据、缓存等数据 end */

    /* 页面数据 start */
    let pageData = reactive({
      loading: false,
      data: {
        customer_id: "",
        company: "",
        director_name: "",
        director_phone: "",
        brand_name: "",
        password: "",
        business_license_img: "",
        product_reg_cert_img: "",
        industry: "",
        province: "",
        city: "",
        region: "",
        company_address: "",
        is_production_line: 0,
        app_marks: []
      }
    });

    // 获取页面数据-详情和编辑时候用到
    const getPageData = async (paramData = {}) => {
      if (pageData.loading) {
        return;
      }
      pageData.loading = true;
      let result = await getAccountApplyForDetail({ id: paramData.id })
        .then((res) => res.data)
        .catch((error) => error);
      pageData.loading = false;
      if ($iscode(result, true, false)) {
        let respData = result.data || {};
        respData.company = respData.company_name || "";
        respData.customer_id = respData.id || "";
        respData.business_license_img = respData.business_license_img || "";
        respData.product_reg_cert_img = respData.product_reg_cert_img || "";
        respData.is_production_line = respData.is_activate_production_line || 0;
        respData.activate_app_marks = respData.activate_app_marks || []
        respData.app_marks = respData.activate_app_marks.map((v) => String(v));

        addressCp.data = [respData.province, respData.city, respData.region];

        pageData.data = respData;
      }
    };

    const formRef = ref();
    let formCp = reactive({
      labelCol: { span: 3 },
      wrapperCol: { span: 16 },
      rules: {
        company: [{ required: true, message: "请输入客户名称" }],
        director_name: [{ required: true, message: "请输入负责人" }],
        director_phone: [{ required: true, message: "请输入负责人电话" }],
        password: [{ required: true, message: "请输入密码" }],
        account: [{ required: true, message: "请输入账号" }],
        brand_name: [{ required: true, message: "请输入品牌名称" }]
      }
    });

    // 处理form数据提交
    const gainFormData = () => {
      let formData = { ...pageData.data,address:pageData.data.company_address };
      return formData;
    };

    const submitPageData = async (paramData) => {
      if (pageData.loading) {
        return;
      }
      if (pageDatum.isAdd) {
        addPageData(paramData);
      } else if (pageDatum.isEdit) {
        updatePageData(paramData);
      }
    };

    const addPageData = async (paramData) => {
      let result = await updateAccountApplyFor(paramData)
        .then((res) => res.data)
        .catch((error) => error);
      pageData.loading = false;
      if ($iscode(result, true, false)) {
        setTimeout(() => {
          $router.push("/brand/accountApplyFor/index?page=" + pageDatum.page);
        }, 1000);
      }
    };
    const updatePageData = async (paramData) => {
      let result = await updateAccountApplyFor(paramData)
        .then((res) => res.data)
        .catch((error) => error);
      pageData.loading = false;
      if ($iscode(result, true, false)) {
        message.success(result.msg);
        setTimeout(() => {
          $router.push("/brand/accountApplyFor/index?page=" + pageDatum.page);
        }, 1000);
      }
    };
    const formOnSubmit = () => {
      formRef.value
        .validate()
        .then(() => {
          submitPageData(gainFormData());
        })
        .catch((error) => {
          console.log("error", error);
        });
    };

    /* 地址选择 start */
    let addressCp = reactive({
      show: false,
      options: [],
      data: []
    });
    const addressOnChange = (e) => {
      pageData.data.province = e[0];
      pageData.data.city = e[1];
      pageData.data.region = e[2];
    };
    const getAddressData = async (paramData) => {
      let result = await getArea()
        .then((res) => res)
        .catch((error) => error);
      addressCp.options = result.data || [];
    };
    /* 地址选择 end */

    /* 行业 start */
    let industryCp = reactive({
      show: false,
      options: [],
      data: []
    });
    const industryOnChange = (e) => {
      console.log("industryOnChange", e);
    };
    const getIndustryData = async (paramData) => {
      let result = await getBrandIndustrys()
        .then((res) => res.data)
        .catch((error) => error);
      if ($iscode(result, true, false)) {
        industryCp.options = result.data || [];
      }
    };
    /* 行业 end */

    /* 产品 start */
    let productCp = reactive({
      show: false,
      options: [],
      data: []
    });
    const productOnChange = (e) => {
      console.log("productOnChange", e);
    };
    const getProductData = async () => {
      let result = await brandGetAppCost({ nopages: 1 })
        .then((res) => res.data)
        .catch((error) => error);
      if ($iscode(result, true, false)) {
        let respData = result.data || {};
        if (respData?.app_type_module?.app_list.length) {
          productCp.options = respData.app_type_module.app_list.map((v) => {
            v["label"] = v["name"];
            v["value"] = v["mark_id"];
            return v;
          });
        }
      }
    };
    /* 产品 end */

    /* 图片上传 start */
    const uploadOnSuccess = (type, data) => {
      console.log("uploadOnSuccess", type, data);
      pageData.data[type] = data.path;
    };
    /* 图片上传 end */

    // 弹窗数据
    const modalCp = reactive({
      show: false,
      type: "add",
      index: 0
    });

    /* 页面数据 end */
    const initPageDatum = () => {
      pageDatum.page = $route.query.page || "";
      pageDatum.pageType = $route.query.type || "";
      pageDatum.id = $route.query.id || "";

      // 如果是作为详情页
      if (pageDatum.pageType == "look" && pageDatum.id) {
        pageDatum.isAdd = false;
        pageDatum.isDetail = true;
        getPageData({ id: pageDatum.id });
      } else if (pageDatum.pageType == "edit" && pageDatum.id) {
        pageDatum.isAdd = false;
        pageDatum.isEdit = true;
        getPageData({ id: pageDatum.id });
      }
    };
    onMounted(() => {
      initPageDatum();
      getAddressData();
      getIndustryData();
      getProductData();
    });

    return {
      info,
      pageDatum,
      pageData,
      formCp,
      formRef,
      formOnSubmit,
      modalCp,
      // 地址
      addressCp,
      addressOnChange,
      // 行业
      industryCp,
      industryOnChange,
      // 产品
      productCp,
      productOnChange,
      // 图片上传
      uploadOnSuccess
    };
  }
};
</script>
